export default "__VITE_ASSET__pfwsIGg0__"